import ProfileModel from "../../../../Profile/Models/ProfileModel";

export default class ClassicQuizRankModel {
  public position: number = null;
  public profileId: string = null;
  public profileModel: ProfileModel = null;
  public points: number = null;
}
